import { QueryEntity } from "@datorama/akita";
import { injectable } from "tsyringe";

import QuestionsStore, { QuestionsState } from "../stores/QuestionsStore";

@injectable()
class QuestionsQuery extends QueryEntity<QuestionsState> {
    constructor(store: QuestionsStore) {
        super(store);
    }
    all$ = this.selectAll();
    paginationMeta$ = this.select((v) => v.paginationMeta);
    status$ = this.select((v) => v.status);
    error$ = this.selectError();
}

export default QuestionsQuery;
